import { useGetAllFavoriteListIdsByProduct } from '@/hooks/bff/favorite/getAllFavoriteListIdsByProducts/useGetAllFavoriteListIdsByProduct'

export const useActionsOfFavoriteList = (productIds: string[]) => {
  const { favoriteListIdsByProduct, isFetching } = useGetAllFavoriteListIdsByProduct(productIds)

  const getListOfFavoriteList = (productId?: string): string[] =>
    productId ? (favoriteListIdsByProduct[productId] ?? []) : []

  return {
    getListOfFavoriteList,
    isLoading: isFetching,
  }
}
